/**
 * 에러 유형
 * @enum {string}
 */
export const ERROR_TYPE = {
    /** 전체화면 */
    FULL_SCREEN: 'FULL_SCREEN',
    /** 팝업 */
    POPUP: 'POPUP'
};